export enum KeyboardKey {
    a = 'a'
}